// Compartilhar (<share-link>): usa o compartilhamento nativo quando o
// aparelho oferece, que é o gesto esperado no celular, e cai para copiar
// o endereço no desktop. Sem JS o elemento continua sendo um link para a
// própria página, que é justamente o que se compartilha.

class ShareLink extends HTMLElement {
  connectedCallback() {
    this.link = this.querySelector('a');
    this.feedback = this.querySelector('[role="status"]');
    if (!this.link) return;

    this.link.addEventListener('click', async (event) => {
      const url = this.dataset.url;
      const title = this.dataset.title;
      if (!url) return;

      if (navigator.share) {
        event.preventDefault();
        try {
          await navigator.share({ title, url });
        } catch {
          // Cancelar não é erro: a pessoa desistiu e nada precisa ser dito.
        }
        return;
      }

      if (navigator.clipboard) {
        event.preventDefault();
        await navigator.clipboard.writeText(url);
        // Some sozinho: um aviso permanente vira ruído na próxima leitura.
        if (this.feedback) {
          this.feedback.textContent = this.dataset.copied ?? '';
          clearTimeout(this.timer);
          this.timer = setTimeout(() => { this.feedback.textContent = ''; }, 2400);
        }
      }
    });
  }
}

if (!customElements.get('share-link')) {
  customElements.define('share-link', ShareLink);
}
